//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getIntegralRecordListApi } from '@/api/user';
import { appletListApi } from "@/api/operation/applet";
export default {
  data: function data() {
    return {
      loading: false,
      typeOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '收入',
        value: 1,
        tag: 'red'
      }, {
        label: '支出',
        value: 2,
        tag: 'green'
      }],
      // sourceOptions: [
      //   { label: '全部', value: '' },
      //   { label: '签到获取', value: '签到获取', tag: 'cyan' },
      //   { label: '即抽即开', value: '即抽即开', tag: 'blue' },
      //   { label: '任务获取', value: '任务获取', tag: 'green' },
      //   { label: '新人红包', value: '新人红包', tag: 'red' },
      //   { label: '兑换红包', value: '兑换红包', tag: 'orange' },
      // ],
      appList: []
    };
  },
  computed: {
    formData: function formData() {
      return [
      // { label: '用户搜索', prop: 'user', type: 'user-select-input' },
      {
        label: '所属应用',
        prop: 'applicationId',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.appList
        }
      }, {
        label: '用户ID',
        prop: 'uid',
        defaultValue: '',
        type: 'input'
      }, {
        label: '流水类型',
        prop: 'type',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.typeOptions
        }
      }, {
        label: '流水来源',
        prop: 'backgroundTitle',
        defaultValue: '',
        type: 'input'
      }, {
        label: '时间',
        prop: 'createTime',
        defaultValue: [],
        type: 'datetimeRange',
        options: {
          startKey: 'startTime',
          endKey: 'endTime',
          startPlaceholder: '开始时间',
          endPlaceholder: '结束时间'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "\u6D41\u6C34\u53F7",
        width: 130
      }, {
        key: 'user',
        visible: true,
        label: "\u7528\u6237",
        width: 160
      }, {
        key: 'applicationName',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 160
      }, {
        key: 'integral',
        visible: true,
        label: "\u91D1\u5E01\u660E\u7EC6",
        width: 100
      }, {
        key: 'type',
        visible: true,
        label: "\u6D41\u6C34\u7C7B\u578B",
        width: 100,
        formatter: 'tag',
        formatOptions: {
          list: this.typeOptions
        }
      }, {
        key: 'backgroundTitle',
        visible: true,
        label: "\u6D41\u6C34\u6765\u6E90",
        width: 100
      },
      // { key: 'c', visible: true, label: `渠道来源`, width: 100 },
      {
        key: 'createTime',
        visible: true,
        label: "\u6D41\u6C34\u65F6\u95F4",
        width: 160
      }];
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      appletListApi(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    getList: function getList(params) {
      return getIntegralRecordListApi(params);
    }
  }
};